import { render, staticRenderFns } from "./SmsForm.vue?vue&type=template&id=760cd72a&scoped=true&"
import script from "./SmsForm.vue?vue&type=script&lang=js&"
export * from "./SmsForm.vue?vue&type=script&lang=js&"
import style0 from "./SmsForm.vue?vue&type=style&index=0&id=760cd72a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760cd72a",
  null
  
)

export default component.exports